import { Box, Divider, Flex, Skeleton, Stack } from '@chakra-ui/react'
import moment from 'moment'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DealTransaction, WalletTransaction } from 'types'
import { currencyFormat } from 'utils/currencyFormat'
import { TransactionRenderer } from '../TransactionRenderer'

interface Props {
  dealTransaction?: WalletTransaction
  onClick: (transaction: WalletTransaction) => void
}

export const MobileRenderer: FC<Props> = ({ dealTransaction, onClick }) => {
  const { t } = useTranslation()

  return (
    <Box paddingBottom={'1.14rem'} onClick={() => dealTransaction && onClick(dealTransaction)}>
      <Box borderRadius={'1.71rem'} boxShadow={'0 0 5.14rem rgba(15, 3, 30, 0.08)'} minH='11.4rem'>
        <Flex px='1.14rem' pt='1.14rem' justifyContent={'space-between'} alignItems='center'>
          {dealTransaction ? (
            <>
              <Flex gap='0.85rem'>
                <TransactionRenderer
                  variant='details'
                  transactionType={dealTransaction.type}
                ></TransactionRenderer>
                <Box>
                  <Box
                    textTransform={'capitalize'}
                    color='brand.black.900'
                    fontSize={'1.14rem'}
                    fontWeight={600}
                    mb='0.28rem'
                  >
                    {dealTransaction.type}
                  </Box>
                  <Box color='brand.black.900' opacity={0.4} fontSize='1rem'>
                    {dealTransaction.reference}
                  </Box>
                </Box>
              </Flex>
              <Box color='brand.black.900' fontSize={'1.14rem'} fontWeight={600}>
                {currencyFormat(dealTransaction.amount)} {dealTransaction.wallet?.currency.slug}
              </Box>
            </>
          ) : (
            <Skeleton></Skeleton>
          )}
        </Flex>
        <Divider my='1.14rem'></Divider>
        <Flex px='1.14rem' pb='1.14rem' justifyContent={'space-between'}>
          <Stack>
            {dealTransaction ? (
              <>
                <Box color='brand.black.900' fontSize={'1.14rem'} opacity={0.4}>
                  Date
                </Box>
                <Box color='brand.black.900' fontSize={'1.14rem'}>
                  {moment(dealTransaction.createdAt).format('MMM DD, YYYY')}
                </Box>
              </>
            ) : (
              <Skeleton></Skeleton>
            )}
          </Stack>
        </Flex>
      </Box>
    </Box>
  )
}
